import { proforientationEventSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationEventDodsYearsSelector = createSelector(
  [proforientationEventSelectors.dods],
  (proforientationEventDods) =>
    extractDatesFromNestedItems(
      [proforientationEventDods],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
